import { modalBibliographyDetailRealStore } from '@/store'
import { ModalBibliographyDetailRealStoreInterface } from '@/store/ModalBibliographyDetailRealStore'

export class ModalBibliographyDetailRealService {
  public open(params: ModalBibliographyDetailRealStoreInterface) {
    modalBibliographyDetailRealStore.open(params)
  }

  public close() {
    modalBibliographyDetailRealStore.close()
  }
}
